export default "__VITE_ASSET__D50KK6y7__"